const budgetingMethodEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/budgeting/budgeting-methods` as const,
  detail: (companyId: string, accountCode: string | number) =>
    `/companies/${companyId}/budgeting/budgeting-methods/${accountCode}` as const
}

export default budgetingMethodEndpoints
